import { useFormikContext } from 'formik';
import { FV } from './share';
import FormField from 'components/FormField';
import { InputNumber, InputNumberProps } from 'antd';
import { isNil } from 'lodash-es';
import { regionMonetaryUnitMap } from 'services/config/region';
import toLowerCase from 'utils/toLowerCase';
import { CountryFlagIcon } from 'components/CountryFlagIcon';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';
import { useDiscountTypeLabel } from './DiscountType';

function DiscountValue({ disabled }: DisabledProps) {
  const { t, discountTypeLabel } = useDiscountTypeLabel();

  const {
    values: { discountType, stores, voucherMinOrderAmount },
  } = useFormikContext<FV>();

  const label = discountTypeLabel[discountType];

  return (
    <FormField<FV['discountValue']>
      name="discountValue"
      required
      label={label}
      validate={(value) => {
        if (!value) {
          return t('department.请输入x', { x: '' });
        }

        if (
          discountType === 'AMOUNT' &&
          voucherMinOrderAmount &&
          Number(value) > Number(voucherMinOrderAmount)
        ) {
          return t('formValidator.rule7');
        }
      }}
    >
      {({ field: { value, onChange, onBlur } }) => {
        const inputNumberProps: InputNumberProps = {
          className: discountType === 'PERCENT' ? '!w-[160px]' : '!w-[250px]',
          disabled,
          placeholder: t('department.请输入x', { x: label }),
          precision: 0,
          min: 1,
          value: value && parseInt(value, 10),
          onChange: (value) => onChange(isNil(value) ? '' : String(value)),
          onBlur,
        };

        if (discountType === 'PERCENT') {
          return <InputNumber {...inputNumberProps} addonAfter="%" max={99} />;
        }

        const [{ region = undefined } = {}] = stores;

        return (
          <InputNumber
            {...inputNumberProps}
            addonAfter={region ? regionMonetaryUnitMap[toLowerCase(region)] : undefined}
            prefix={region ? <CountryFlagIcon region={region} /> : undefined}
            max={9999999}
          />
        );
      }}
    </FormField>
  );
}

export default DiscountValue;
